import React from "react";

export default function SuccessMessage({ text }) {
  return <div className="success_alert">{text}</div>;
}
